module.exports = __webpack_public_path__ + "img/top-3-0.055cefd8.jpg";